import { BitfStrapiModel } from '@common/libs/bitforce/core/models';
import { User } from './user.model';

export class Payment extends BitfStrapiModel {
  user: User;
  netPrice: number;
  vatCost: number;
  grossPrice: number;
  cashCost?: number;
  paymentDate?: Date;

  constructor(data: Partial<Payment> = {}) {
    super({ data });

    if (data.user) {
      this.user = new User(data.user);
    }

    this.paymentDate = data.paymentDate ? new Date(data.paymentDate) : undefined;
  }

  get serialised(): any {
    return {
      id: this.id,
      user: this.user?.id,
      netPrice: this.netPrice,
      vatCost: this.vatCost,
      grossPrice: this.grossPrice,
      cashCost: this.cashCost,
      paymentDate: this.paymentDate ? this.paymentDate.toISOString() : null,
    };
  }
}
